import React, { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { ChevronLeft, ChevronRight, X } from "lucide-react"
import PhotoPlaceholder from "../PhotoPlaceholder"

const Lightbox = ({ photos, index, onClose, onNav }) => {
  const [failed, setFailed] = useState({})

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose()
      if (e.key === "ArrowRight") onNav(1)
      if (e.key === "ArrowLeft") onNav(-1)
    }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [onClose, onNav])

  if (index === null) return null

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 z-50 bg-[#26303D]/90 flex items-center justify-center p-6"
      >
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          onClick={onClose}
          className="absolute top-5 right-5 text-white/80 hover:text-white"
          aria-label="Close gallery"
        >
          <X size={26} />
        </motion.button>
        <button
          onClick={(e) => {
            e.stopPropagation()
            onNav(-1)
          }}
          className="absolute left-3 md:left-8 text-white/70 hover:text-white p-2"
          aria-label="Previous photo"
        >
          <ChevronLeft size={28} />
        </button>
        {failed[index] ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            onClick={(e) => e.stopPropagation()}
            className="w-[60vw] max-w-md h-[40vh] rounded-lg shadow-2xl overflow-hidden"
          >
            <PhotoPlaceholder />
          </motion.div>
        ) : (
          <motion.img
            key={index}
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2 }}
            src={photos[index]}
            onClick={(e) => e.stopPropagation()}
            onError={() => setFailed((f) => ({ ...f, [index]: true }))}
            alt=""
            className="max-h-[80vh] max-w-[88vw] rounded-lg object-contain shadow-2xl"
          />
        )}
        <button
          onClick={(e) => {
            e.stopPropagation()
            onNav(1)
          }}
          className="absolute right-3 md:right-8 text-white/70 hover:text-white p-2"
          aria-label="Next photo"
        >
          <ChevronRight size={28} />
        </button>
        <div className="absolute bottom-6 text-white/60 text-xs font-mono">
          {index + 1} / {photos.length}
        </div>
      </motion.div>
    </AnimatePresence>
  )
}

export default Lightbox
